import { track } from '@amplitude/analytics-browser';
import { Component } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Session, SessionService } from './auth/session/session.service';
import { SsoRedirectService } from './shared/services/sso-redirect/sso-redirect.service';
declare const newrelic: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private sessionService: SessionService,
    private ssoRedirectService: SsoRedirectService,
  ) {
    this.currentSession = this.sessionService.getCurrentSession();
  }
  title = 'Lytx Device Control Center';
  isAuthenticated: boolean | undefined;
  userGroups: string[] | undefined;
  token: any;
  userInfo: any;
  isFirstLoad = true;
  currentSession: Session;

  async ngOnInit() {
    if (!this.currentSession) {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (token) {
        this.token = token;
        const newUrl = window.location.href.replace(`token=${token}`, '');
        window.history.replaceState({}, document.title, newUrl);
      } else {
        this.ssoRedirectService.redirectToSso();
      }
    }

    if (this.currentSession || this.token) {
      let session: any;
      let userName: string;
      let userEmail: string;

      if (this.currentSession) {
        session = this.currentSession;
        userName = session.name;
        userEmail = session.email;
      } else if (this.sessionService.tokenIsExpired(this.token)) {
        this.ssoRedirectService.redirectToSso();
      } else {
        session = jwt_decode(this.token);
        const firstName = session['firstName'];
        const lastName = session['lastName'];
        userName = `${firstName} ${lastName}`.trim();
        userEmail = session['email'];
      }

      if (typeof newrelic !== 'undefined') {
        newrelic.addPageAction('UserName', { userName });
      }

      const eventProperties = {
        userDetails: [userName, userEmail],
      };

      track('Control Center Active User', eventProperties);

      if (this.token) {
        this.userGroups = session.groups as string[];
        this.sessionService.initializeSession(
          this.token,
          userName,
          userEmail,
          this.userGroups,
        );
      }
    }
  }
}
